import makeApiCall from "./axiosIndex";
const quotationApis = {
  quotationsCreationMethod: (data: any) =>
    makeApiCall({
      url: "/quotation-buyer/new",
      method: "post",
      data,
    }),
  newVersion: (data: any) =>
    makeApiCall({
      url: "/quotation-buyer/newVersion",
      method: "post",
      data,
    }),
  fetchList: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-buyer/list`,
    }),
  getById: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-buyer/getById`,
      params: { quotationId },
    }),
  fetchCounts: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-buyer/getCounts`,
    }),
  fetchPendingApprovals: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-buyer/pendingApprovals`,
    }),
  approve: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "put",
      url: `/quotation-buyer/approve`,
      params: { quotationId },
    }),
  reject: (quotationId: any, reason: any): Promise<any> =>
    makeApiCall({
      method: "put",
      url: `/quotation-buyer/reject`,
      params: { quotationId, reason },
    }),
  Summary: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/funnel`,
      params: { quotationId },
    }),
  versionGraph: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/versionGraph`,
      params: { quotationId },
    }),
  approvalDetilsEventChain: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-buyer/approvalsByQuotationId`,
      params: { quotationId },
    }),
  quoteComparision: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/quoteComparision`,
      params: { quotationId },
    }),
  addScenarioBuilder: (data: any): Promise<any> =>
    makeApiCall({
      method: "post",
      url: `/quotation-buyer/addScenarioBuilder`,
      data,
    }),
  getScenarioBuilder: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-buyer/getScenarioBuilder`,
      params: { quotationId },
    }),
  dynamicRankings: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/dynamicRankings`,
      params: { quotationId },
    }),
  shortListSuppliers: (quotationId: any, data: any): Promise<any> =>
    makeApiCall({
      method: "post",
      url: `/quotation-seller/shortListSuppliers`,
      params: { quotationId },
      data,
    }),
  getShortListed: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/getShortListed`,
      params: { quotationId },
    }),
  sendToQCApproval: (data: any, quotationId: any): Promise<any> =>
    makeApiCall({
      method: "post",
      url: `/quotation-seller/sendToQCApproval`,
      params: { quotationId },
      data,
    }),
  getQCList: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/getQCList`,
    }),
  getByQCId: (qcId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/getByQCId`,
      params: { qcId },
    }),
  qcApprove: (data: any): Promise<any> =>
    makeApiCall({
      method: "put",
      url: `/quotation-seller/approveQC`,
      data,
    }),
  qcReject: (data: any): Promise<any> =>
    makeApiCall({
      method: "put",
      url: `/quotation-seller/rejectQC`,
      data,
    }),
  editShortListed: (data: any): Promise<any> =>
    makeApiCall({
      method: "put",
      url: `/quotation-seller/editShortListed`,
      data,
    }),
  removeShortListed: (quotationId: any, id: any): Promise<any> =>
    makeApiCall({
      method: "put",
      url: `/quotation-seller/removeShortListed`,
      params: { quotationId, id },
    }),
  getQCApprovedList: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/getQCApprovedList`,
    }),
  getQCApprovedById: (qcId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/getQCApprovedById`,
      params: { qcId },
    }),
  addTargetPrice: (data: any): Promise<any> =>
    makeApiCall({
      method: "post",
      url: `/quotation-buyer/addTargetPrice`,
      data,
    }),
  quotationTimeLine: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/quotationTimeLine`,
      params: { quotationId },
    }),
  latestByQuotationId: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/latestByQuotationId`,
      params: { quotationId },
    }),
  submitSupplierQuote: (data: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-seller/quote",
      method: "post",
      data: data,
    }),
  fetchShortListBySupplierId: (
    quotationId: any,
    supplierId: any
  ): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/fetchShortListBySupplierId`,
      params: { quotationId, supplierId },
    }),
  quotationDashboardCounts: (data: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-buyer/quotationDashboardCounts",
      method: "post",
      data: data,
    }),
  latestBySupplierQuotationId: (
    quotationId: any,
    supplierId: any,
    isNewSupplier: any
  ): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/latestBySupplierQuotationId`,
      params: { quotationId, supplierId, isNewSupplier },
    }),
  quotationSummary: (data: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-dashboard/quotationSummary",
      method: "post",
      data: data,
    }),
  quotationMaterialWiseSavings: (data: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-dashboard/quotationMaterialWiseSavings",
      method: "post",
      data: data,
    }),
  quotationResponseTime: (data: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-dashboard/quotationResponseTime",
      method: "post",
      data: data,
    }),
  quotationTop10NegotiationByMaterials: (data: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-dashboard/quotationTop10NegotiationByMaterials",
      method: "post",
      data: data,
    }),
  quotationMonthOnMonthSavings: (data: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-dashboard/quotationMonthOnMonthSavings",
      method: "post",
      data: data,
    }),
  convertToPO: (data: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-seller/convertToPO",
      method: "post",
      data: data,
    }),
  viewAllQCs: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-buyer/viewAllQCs`,
    }),
  getLinesByQCId: (qcId: any, quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/getLinesByQCId`,
      params: { qcId, quotationId },
    }),
  getNotRespondedSuppliers: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/unpublishedSuppliers`,
      params: { quotationId },
    }),
  selfQuote: (data: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-seller/selfQuote",
      method: "post",
      data: data,
    }),
  emailNotify: (quotationId: any, data: any): Promise<any> =>
    makeApiCall({
      url: `/quotation-buyer/emailNotify/${quotationId}`,
      method: "post",
      data,
    }),
  getLatestBySupplierQuotationId: (
    quotationId: any,
    supplierId: any
  ): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-seller/latestBySupplierQuotationId`,
      params: { quotationId, supplierId },
    }),
  qcExcelExport: (quotationId: any): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `quotation-seller/quoteComparisonExcelExport`,
      params: { quotationId },
    }),
  quoteNewVersion: (data: any) =>
    makeApiCall({
      url: "/quotation-seller/selfQuoteNewVersion",
      method: "post",
      data,
    }),
  fetchRFQPaginationList: (params: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-buyer/paginationList",
      method: "get",
      params,
    }),
  fetchRFQPaginationPendingApprovals: (params: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-buyer/paginationPendingApprovals",
      method: "get",
      params,
    }),
  fetchQCPagination: (params: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-seller/qcPaginationList",
      method: "get",
      params,
    }),
  fetchQCApprovalsPaginationPendingApprovals: (params: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-seller/qcPendingPaginationList",
      method: "get",
      params,
    }),
  fetchReadyToRewardPaginationPendingApprovals: (params: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-seller/qcApprovedPaginationList",
      method: "get",
      params,
    }),
  fetchStatusFilterOptions: (): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-buyer/status`,
    }),
  fetchOrderVersions: (id: string): Promise<any> =>
    makeApiCall({
      method: "get",
      url: `/quotation-buyer/versions?rfqId=${id}`,
    }),
  fetchPurchaseHistoryData: (data: any): Promise<any> =>
    makeApiCall({
      method: "post",
      url: `/quotation-seller/fetchLatestMaterialPricesList`,
      data,
    }),
  materialBulkUploadCreate: (data: any): Promise<any> =>
    makeApiCall({
      method: "post",
      url: "/quotation-buyer/materialBulkUploadCreate",
      data,
    }),
  rfqPriceBulkUpload: (data: any): Promise<any> =>
    makeApiCall({
      url: "/quotation-seller/rfqPriceBulkUpload",
      method: "post",
      data: data,
    }),
  qcApproveMultipleLines: (data: any): Promise<any> =>
    makeApiCall({
      method: "put",
      url: `/quotation-seller/approveMultiLineQC`,
      data,
    }),
  qcRejectMultipleLines: (data: any): Promise<any> =>
    makeApiCall({
      method: "put",
      url: `/quotation-seller/rejectMultiLineQC`,
      data,
    }),
};

export default quotationApis;
